export default {
  PRODUCTITEM: {
    OUTOFSTOCK: 'Out Of Stock',
    AVAILABLESTOCK: 'Available stock: {stock}'
  }
}
